<template>
  <modal-wrapper>
    <modal-container :show-close="false" @close="closeNonResidentModal">
      <div class="nonresident-modal">
        <img
          src="@/assets/img/logo.svg"
          class="register-page__modal-logo"
          width="100"
          height="40"
        />
        <div
          class="register-page__modal-heading"
          v-html="$t('notifications.non-resident-modal')"
        >
        </div>
        <div class="nonresident-modal__info">
          {{ $t('notifications.non-resident-text') }}
        </div>
        <icu-contacts view-type="horizontal" />
        <div class="register-page__modal-buttons">
          <pc-button variant="dark" class="full-width" @click="closeNonResidentModal">
            OK
          </pc-button>
        </div>
      </div>
    </modal-container>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '@/components/modals/ModalWrapper'
import ModalContainer from '@/components/modals/ModalContainer'
import PcButton from '@/components/common/PcButton.vue'
import IcuContacts from '@/components/common/IcuContacts'
export default {
  name: 'NonResidentModal',
  components: {IcuContacts, PcButton, ModalContainer, ModalWrapper},
  methods: {
    closeNonResidentModal() {
      window.location.href = process.env.VUE_APP_LANDING_REDIRECT_URL
    }
  }
}
</script>

<style scoped>

</style>
